(function () {
  var qtyUpdateTimers = {};
  var qtyUpdateInFlight = {};
  var qtyDesiredValues = {};
  var QTY_DEBOUNCE_MS = 220;

  function getMoneyFormat() {
    var drawer = getDrawer();
    var fromDrawer = drawer ? drawer.getAttribute('data-money-format') : '';
    if (fromDrawer) return fromDrawer;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    return '{{amount}}';
  }

  function moneyFormat(cents) {
    if (cents == null) return '';
    var amount = (Number(cents) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Number(cents) / 100));
    var fmt = getMoneyFormat();
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getCartUrl(path) {
    var routes = window.routes || {};
    if (path === 'cart') return routes.cart_url || '/cart';
    if (path === 'cartJs') return (routes.cart_url || '/cart') + '.js';
    if (path === 'change') return '/cart/change.js';
    return '/cart.js';
  }

  function getDrawer() {
    return document.getElementById('BisonStaticCartDrawer');
  }

  function getItemsContainer() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('[data-bison-cart-items]') : null;
  }

  function getCountNodes() {
    var drawer = getDrawer();
    if (!drawer) return [];
    return drawer.querySelectorAll('[data-bison-cart-count]');
  }

  function getTotalNode() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('[data-bison-cart-total]') : null;
  }

  function getRecommendationsRoot() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('[data-bison-recommendations-root]') : null;
  }

  function applyCheckoutDiscount(block, highestTierCode) {
    var checkoutBase = (block.getAttribute('data-checkout-base') || '/checkout').trim() || '/checkout';
    var checkoutLink = document.getElementById('bison-cart-checkout-link');
    if (!checkoutLink) return;
    var href = checkoutBase;
    if (highestTierCode && highestTierCode.length) {
      href += (href.indexOf('?') >= 0 ? '&' : '?') + 'discount=' + encodeURIComponent(highestTierCode);
    }
    checkoutLink.href = href;
  }

  function getDiscountTiers(block) {
    var tiers = [];
    try {
      var tiersRaw = block.getAttribute('data-tiers');
      if (tiersRaw) tiers = JSON.parse(tiersRaw);
    } catch (e) {}
    if (!Array.isArray(tiers) || tiers.length === 0) {
      tiers = [
        { threshold: 3300, label: '5% Discount', code: '' },
        { threshold: 6600, label: '10% Discount', code: '' },
        { threshold: 9900, label: '15% Discount', code: '' },
      ];
    }
    return tiers
      .filter(function (tier) {
        return tier && !isNaN(parseInt(tier.threshold, 10));
      })
      .sort(function (a, b) {
        return parseInt(a.threshold, 10) - parseInt(b.threshold, 10);
      });
  }

  function getCartSubtotal(cart) {
    if (cart && typeof cart.items_subtotal_price === 'number') return cart.items_subtotal_price;
    if (cart && typeof cart.original_total_price === 'number') return cart.original_total_price;
    return cart && cart.total_price ? cart.total_price : 0;
  }

  /* Legacy: all discount tiers visible as steps (rollback via data-progress-mode="steps"). */
  function updateDiscountProgressStepsLegacy(block, tiers, total) {
    var legacyRoot = block.querySelector('.bison-static-progress--legacy');
    if (!legacyRoot) return;

    var maxThreshold = parseInt(block.getAttribute('data-max-threshold') || '9900', 10);
    var lineEl = legacyRoot.querySelector('[data-bison-progress-line-legacy]');
    if (lineEl) {
      var pct = maxThreshold > 0 ? Math.min(100, Math.floor((total * 100) / maxThreshold)) : 100;
      lineEl.style.setProperty('--progress-fill', pct + '%');
    }

    var highestTierCode = '';
    var highestUnlockedIndex = -1;
    var highestUnlockedThreshold = -1;
    var highestCodeThreshold = -1;
    var tierCount = tiers.length;

    tiers.forEach(function (tier, index) {
      var stepEl = legacyRoot.querySelector('[data-bison-step="' + index + '"]');
      if (!stepEl) return;
      var th = parseInt(tier.threshold, 10) || 0;
      var stepPct = maxThreshold > 0 ? Math.min(100, Math.floor((th * 100) / maxThreshold)) : 0;
      stepEl.style.left = stepPct + '%';
      var isReached = total >= th;
      stepEl.classList.toggle('is-reached', isReached);
      stepEl.classList.toggle('is-edge-start', index === 0);
      stepEl.classList.toggle('is-edge-end', index === tierCount - 1);
      if (isReached && th > highestUnlockedThreshold) {
        highestUnlockedThreshold = th;
        highestUnlockedIndex = index;
      }
      if (isReached && tier.code && th >= highestCodeThreshold) {
        highestCodeThreshold = th;
        highestTierCode = String(tier.code).trim();
      }
    });

    block.setAttribute('data-active-tier', String(highestUnlockedIndex));
    block.setAttribute('data-unlocked-tier', String(highestUnlockedIndex));
    applyCheckoutDiscount(block, highestTierCode);
  }

  function updateDiscountProgressSingle(block, tiers, total) {
    var highestTierCode = '';
    var highestUnlockedIndex = -1;
    var highestUnlockedThreshold = -1;
    var highestCodeThreshold = -1;
    var activeIndex = -1;
    var activeTier = null;

    tiers.forEach(function (tier, index) {
      var th = parseInt(tier.threshold, 10) || 0;
      var isReached = total >= th;
      if (isReached && th > highestUnlockedThreshold) {
        highestUnlockedThreshold = th;
        highestUnlockedIndex = index;
      }
      if (isReached && tier.code && th >= highestCodeThreshold) {
        highestCodeThreshold = th;
        highestTierCode = String(tier.code).trim();
      }
      if (!isReached && activeTier === null) {
        activeIndex = index;
        activeTier = tier;
      }
    });

    var singleRoot = block.querySelector('.bison-static-progress--single');
    var messageEl = block.querySelector('[data-bison-progress-message]');
    var lineEl = singleRoot ? singleRoot.querySelector('[data-bison-progress-line]') : null;

    if (activeTier) {
      var activeThreshold = parseInt(activeTier.threshold, 10) || 0;
      var remaining = Math.max(0, activeThreshold - total);
      var pct =
        activeThreshold > 0 ? Math.min(100, Math.floor((total * 100) / activeThreshold)) : 100;
      var label = String(activeTier.label || 'your reward').trim();

      if (messageEl) {
        messageEl.innerHTML =
          'Spend <strong>' +
          moneyFormat(remaining) +
          '</strong> more for <strong>' +
          escapeHtml(label) +
          '</strong>!';
      }
      if (lineEl) lineEl.style.setProperty('--progress-fill', pct + '%');
      if (singleRoot) singleRoot.classList.remove('is-complete');
      block.setAttribute('data-active-tier', String(activeIndex));
    } else if (tiers.length) {
      var lastTier = tiers[tiers.length - 1];
      var lastLabel = String((lastTier && lastTier.label) || 'your discount').trim();

      if (messageEl) {
        messageEl.innerHTML =
          'You\'ve unlocked <strong>' + escapeHtml(lastLabel) + '</strong>!';
      }
      if (lineEl) lineEl.style.setProperty('--progress-fill', '100%');
      if (singleRoot) singleRoot.classList.add('is-complete');
      block.setAttribute('data-active-tier', String(tiers.length - 1));
    }

    block.setAttribute('data-unlocked-tier', String(highestUnlockedIndex));
    applyCheckoutDiscount(block, highestTierCode);
  }

  function updateDiscountProgress(cart) {
    var block = getDrawer() && getDrawer().querySelector('[data-bison-discount-block]');
    if (!block) return;

    var tiers = getDiscountTiers(block);
    var total = getCartSubtotal(cart);
    var mode = (block.getAttribute('data-progress-mode') || 'single').trim();

    if (mode === 'steps') {
      updateDiscountProgressStepsLegacy(block, tiers, total);
      return;
    }

    updateDiscountProgressSingle(block, tiers, total);
  }

  function buildCartItemHtml(item, line) {
    var imageSrc = item.image || 'https://dummyimage.cloudtechsolution.co/160x160/cccccc/000000.png';
    var oldPriceHtml =
      item.original_line_price > item.final_line_price
        ? '<span class="old">' + moneyFormat(item.original_line_price) + '</span>'
        : '';

    return (
      '<article class="bison-static-cart-item" data-line="' +
      line +
      '">' +
      '<img src="' +
      imageSrc +
      '" alt="' +
      escapeHtml(item.product_title) +
      '" loading="lazy" width="80" height="80">' +
      '<div class="bison-static-cart-item__content">' +
      '<div class="bison-static-cart-item__title-row">' +
      '<h6>' +
      escapeHtml(item.product_title) +
      '</h6>' +
      '<button type="button" class="bison-static-delete" aria-label="Remove item" data-bison-remove-line="' +
      line +
      '">' +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M9 3h6m-9 4h12m-1 0-1 12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2L7 7m3 4v6m4-6v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>' +
      '</button>' +
      '</div>' +
      '<div class="bison-static-cart-item__meta">' +
      '<div class="bison-static-stepper">' +
      '<button type="button" data-bison-qty-change="' +
      line +
      '" data-bison-qty-delta="-1">&minus;</button>' +
      '<span>' +
      item.quantity +
      '</span>' +
      '<button type="button" data-bison-qty-change="' +
      line +
      '" data-bison-qty-delta="1">&plus;</button>' +
      '</div>' +
      '<div>' +
      oldPriceHtml +
      '<span class="new">' +
      moneyFormat(item.final_line_price) +
      '</span>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function renderCartItems(cart) {
    var itemsContainer = getItemsContainer();
    if (!itemsContainer) return;

    if (!cart.items || !cart.items.length) {
      itemsContainer.innerHTML =
        '<article class="bison-static-cart-item bison-static-cart-item--empty"><div class="bison-static-cart-item__content"><h6>Your cart is empty.</h6></div></article>';
    } else {
      itemsContainer.innerHTML = cart.items
        .map(function (item, index) {
          return buildCartItemHtml(item, index + 1);
        })
        .join('');
    }

    getCountNodes().forEach(function (node) {
      node.textContent = cart.item_count;
    });

    var totalNode = getTotalNode();
    if (totalNode) totalNode.textContent = moneyFormat(cart.total_price);

    var checkoutLink = document.getElementById('bison-cart-checkout-link');
    if (checkoutLink) {
      checkoutLink.setAttribute('aria-disabled', cart.item_count ? 'false' : 'true');
      checkoutLink.classList.toggle('is-disabled', !cart.item_count);
    }

    updateDiscountProgress(cart);
  }

  function fetchCart() {
    return fetch(getCartUrl('cartJs'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to fetch cart');
      return res.json();
    });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Math.max(1, Number(quantity) || 1),
      }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to add recommended product');
      return res.json();
    });
  }

  function isCarouselMode() {
    return window.matchMedia('(max-width: 899px)').matches;
  }

  function setActiveRecommendation(sliderEl, nextIndex, animate) {
    if (!sliderEl) return;
    var cards = sliderEl.querySelectorAll('.bison-static-recommend__card[data-rec-index]');
    if (!cards.length) return;
    var totalCards = cards.length;
    var normalized = ((nextIndex % totalCards) + totalCards) % totalCards;
    sliderEl.setAttribute('data-rec-current-index', String(normalized));
    // Slide the track: translate by one card-width (100%) per index.
    sliderEl.style.transition = animate === false ? 'none' : '';
    sliderEl.style.transform = 'translateX(' + (-normalized * 100) + '%)';
    cards.forEach(function (card) {
      var idx = parseInt(card.getAttribute('data-rec-index'), 10) || 0;
      var active = idx === normalized;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    var root = getRecommendationsRoot();
    if (root) {
      root.querySelectorAll('[data-rec-nav]').forEach(function (btn) {
        btn.disabled = totalCards <= 1;
      });
    }
  }

  function initRecommendationsUI() {
    var root = getRecommendationsRoot();
    if (!root) return;
    var slider = root.querySelector('[data-bison-recommend-slider]');
    if (!slider) return;
    var cards = slider.querySelectorAll('.bison-static-recommend__card[data-rec-index]');
    if (!isCarouselMode()) {
      // Desktop flyout: show all cards as a vertical list (no transform).
      slider.style.transition = 'none';
      slider.style.transform = '';
      cards.forEach(function (card) {
        card.classList.add('is-active');
        card.setAttribute('aria-hidden', 'false');
      });
      return;
    }
    // Mobile: single-card sliding carousel. Snap to the first card without animating.
    setActiveRecommendation(slider, 0, false);
  }

  function refreshRecommendations() {
    var root = getRecommendationsRoot();
    if (!root) return Promise.resolve();
    var url = window.location.pathname + '?section_id=cart-drawer-recommendations-bison';
    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to refresh recommendations');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('#shopify-section-cart-drawer-recommendations-bison');
        root.innerHTML = section ? section.innerHTML : html;
        initRecommendationsUI();
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function publishCartCount(count) {
    var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
    bubbles.forEach(function (bubble) {
      bubble.textContent = count;
      var wrap = bubble.closest('.cart-count-bubble');
      if (wrap) wrap.classList.toggle('hidden', count < 1);
    });

    document.dispatchEvent(
      new CustomEvent('bison:cart:updated', {
        detail: { item_count: count },
      })
    );
  }

  function updateLine(line, quantity) {
    return fetch(getCartUrl('change'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: line,
        quantity: quantity,
      }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to update cart line');
      return res.json();
    });
  }

  function setQuantityNode(line, quantity) {
    var drawer = getDrawer();
    if (!drawer) return;
    var qtyNode = drawer.querySelector(
      '[data-bison-qty-change="' + line + '"][data-bison-qty-delta="-1"]'
    );
    if (!qtyNode) return;
    var stepper = qtyNode.closest('.bison-static-stepper');
    var valueNode = stepper ? stepper.querySelector('span') : null;
    if (valueNode) valueNode.textContent = quantity;
  }

  function lockLineControls(line, isLocked) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer
      .querySelectorAll('[data-bison-qty-change="' + line + '"], [data-bison-remove-line="' + line + '"]')
      .forEach(function (btn) {
        btn.disabled = !!isLocked;
      });
  }

  function scheduleQuantityUpdate(line, quantity) {
    qtyDesiredValues[line] = quantity;
    clearTimeout(qtyUpdateTimers[line]);

    qtyUpdateTimers[line] = setTimeout(function () {
      if (qtyUpdateInFlight[line]) return;

      qtyUpdateInFlight[line] = true;
      lockLineControls(line, true);

      updateLine(line, qtyDesiredValues[line])
        .then(function (cart) {
          renderCartItems(cart);
          publishCartCount(cart.item_count);
          refreshRecommendations();
        })
        .catch(function (error) {
          console.error(error);
          refreshCartUI().catch(function (refreshError) {
            console.error(refreshError);
          });
        })
        .finally(function () {
          qtyUpdateInFlight[line] = false;
          lockLineControls(line, false);
          delete qtyDesiredValues[line];
        });
    }, QTY_DEBOUNCE_MS);
  }

  function refreshCartUI() {
    return fetchCart().then(function (cart) {
      renderCartItems(cart);
      publishCartCount(cart.item_count);
      return refreshRecommendations().then(function () {
        return cart;
      });
    });
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    refreshCartUI().catch(function (error) {
      console.error(error);
    });
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function bind() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('[data-bison-static-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    var checkoutLink = document.getElementById('bison-cart-checkout-link');
    if (checkoutLink && !checkoutLink.dataset.bisonCheckoutBound) {
      checkoutLink.dataset.bisonCheckoutBound = '1';
      checkoutLink.addEventListener('click', function (e) {
        if (checkoutLink.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
        }
      });
    }

    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && !cartIcon.dataset.bisonStaticCartBound) {
      cartIcon.dataset.bisonStaticCartBound = '1';
      cartIcon.setAttribute('role', 'button');
      cartIcon.setAttribute('aria-haspopup', 'dialog');
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    if (!drawer.dataset.bisonOutsideCloseBound) {
      drawer.dataset.bisonOutsideCloseBound = '1';
      document.addEventListener('click', function (event) {
        if (!drawer.classList.contains('is-open')) return;
        var panel = drawer.querySelector('.bison-static-cart-drawer__panel');
        if (!panel) return;
        if (event.target && event.target.closest && event.target.closest('#cart-icon-bubble')) return;
        if (panel.contains(event.target)) return;
        closeDrawer();
      });
    }

    if (!drawer.dataset.bisonCartDelegated) {
      drawer.dataset.bisonCartDelegated = '1';
      drawer.addEventListener('click', function (event) {
        var recNavBtn = event.target.closest('[data-rec-nav]');
        if (recNavBtn) {
          var navRoot = getRecommendationsRoot();
          var slider = navRoot ? navRoot.querySelector('[data-bison-recommend-slider]') : null;
          if (!slider) return;
          var currentIndex = parseInt(slider.getAttribute('data-rec-current-index') || '0', 10) || 0;
          var direction = recNavBtn.getAttribute('data-rec-nav') === 'prev' ? -1 : 1;
          setActiveRecommendation(slider, currentIndex + direction);
          return;
        }

        var recAddBtn = event.target.closest('[data-rec-add-cart]');
        if (recAddBtn) {
          var recCard = recAddBtn.closest('.bison-static-recommend__card');
          if (!recCard) return;
          var variantId = recCard.getAttribute('data-rec-variant-id');
          if (!variantId) return;
          var addQty = 1;
          recAddBtn.disabled = true;
          addToCart(variantId, addQty)
            .then(function () {
              return refreshCartUI();
            })
            .catch(function (error) {
              console.error(error);
            })
            .finally(function () {
              recAddBtn.disabled = false;
            });
          return;
        }

        var removeButton = event.target.closest('[data-bison-remove-line]');
        if (removeButton) {
          var removeLine = parseInt(removeButton.getAttribute('data-bison-remove-line'), 10);
          if (!removeLine) return;
          updateLine(removeLine, 0)
            .then(function (cart) {
              renderCartItems(cart);
              publishCartCount(cart.item_count);
              refreshRecommendations();
            })
            .catch(function (error) {
              console.error(error);
            });
          return;
        }

        var qtyButton = event.target.closest('[data-bison-qty-change]');
        if (qtyButton) {
          var line = parseInt(qtyButton.getAttribute('data-bison-qty-change'), 10);
          var delta = parseInt(qtyButton.getAttribute('data-bison-qty-delta'), 10);
          if (!line || !delta) return;
          var itemEl = qtyButton.closest('.bison-static-cart-item');
          var quantityNode = itemEl ? itemEl.querySelector('.bison-static-stepper span') : null;
          var currentQty = quantityNode ? parseInt(quantityNode.textContent, 10) : 1;
          var nextQty = Math.max(0, currentQty + delta);
          setQuantityNode(line, nextQty);
          scheduleQuantityUpdate(line, nextQty);
        }
      });
    }

    if (!drawer.dataset.bisonRecResizeBound) {
      drawer.dataset.bisonRecResizeBound = '1';
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initRecommendationsUI, 150);
      });
    }

    initRecommendationsUI();
  }

  window.BisonStaticCartDrawer = { open: openDrawer, close: closeDrawer };

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();
